var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-reading-list",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-reading-list:not(.animated) .animable {opacity: 0;}svg#freepik_stories-reading-list.animated #freepik--Floor--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--Shadows--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--Plants--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--speech-bubble--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--Chair--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--Character--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 356.46px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-7",
    cx: 250,
    cy: 356.46,
    rx: 217.36,
    ry: 128.93,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "250px 356.46px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-7",
    className: "animable",
    style: {
      transformOrigin: "244.88px 385.601px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-7",
    cx: 330.97,
    cy: 337.09,
    rx: 70.77,
    ry: 40.86,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "330.97px 337.09px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-7",
    cx: 153.07,
    cy: 380.16,
    rx: 65.05,
    ry: 37.56,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.07px 380.16px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M164,410.3l111.57,64.41a2.37,2.37,0,0,0,2.17,0l58.76-33.92c.6-.35.6-.91,0-1.25L225,375.12a2.37,2.37,0,0,0-2.17,0L164,409.05C163.42,409.39,163.42,410,164,410.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "250.258px 424.915px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-7",
    className: "animable",
    style: {
      transformOrigin: "254.047px 271.235px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-7",
    className: "animable",
    style: {
      transformOrigin: "439.473px 271.235px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.26,312.16l-9.52-5.5s-2.34-20.4-.78-36.2c2.18-22.21,16.52-48.92,33.62-42.65s-7.84,28.89-13.39,47.72S425.26,312.16,425.26,312.16Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "434.453px 269.52px"
    },
    id: "el42lwfdpqnig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7wk9mmykzq3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.26,312.16l-9.52-5.5s-2.34-20.4-.78-36.2c2.18-22.21,16.52-48.92,33.62-42.65s-7.84,28.89-13.39,47.72S425.26,312.16,425.26,312.16Z",
    style: {
      opacity: 0.15,
      transformOrigin: "434.453px 269.52px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.25,309.84h0a.58.58,0,0,0,.56-.59c-1.67-49.34,22.89-74.15,23.13-74.4a.57.57,0,0,0,0-.81.58.58,0,0,0-.82,0c-.25.25-25.16,25.42-23.47,75.26A.57.57,0,0,0,420.25,309.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.838px 271.856px"
    },
    id: "elwiikq9ijrgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.25,315.59l-6.78-3.92s-1.15-14,5.72-31c6-14.81,20.8-27.09,28.25-24.51s7.28,7.87,3.64,13.41S436.33,288.34,431.25,315.59Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "444.46px 285.703px"
    },
    id: "elztzl1es1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.68,314.1h0a.57.57,0,0,0,.57-.58c-.13-31.19,29.16-52.27,29.45-52.48a.58.58,0,0,0,.14-.81.56.56,0,0,0-.8-.13c-.3.21-30.08,21.64-29.94,53.43A.58.58,0,0,0,427.68,314.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "442.523px 287.043px"
    },
    id: "elrlaz45cnfh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-7",
    className: "animable",
    style: {
      transformOrigin: "67.261px 271.913px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.63,303.34l8-4.64s4.78-19.86,2.87-37.74C87.86,235.83,71.32,226.38,65,228.54S56.92,238,67.33,253C73.47,261.82,81,280.22,79.63,303.34Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "75.42px 265.791px"
    },
    id: "elfhecfjcb8qh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp8cedeumdt"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "75.42px 265.791px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.63,303.34l8-4.64s4.78-19.86,2.87-37.74C87.86,235.83,71.32,226.38,65,228.54S56.92,238,67.33,253C73.47,261.82,81,280.22,79.63,303.34Z",
    id: "eldz9hs7ankwe",
    className: "animable",
    style: {
      transformOrigin: "75.42px 265.791px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83,293.58h-.08a.55.55,0,0,1-.44-.65c4.4-23.18-3.69-49.22-13.72-60.06a.56.56,0,0,1,0-.79.57.57,0,0,1,.79,0c10.21,11,18.46,37.51,14,61A.56.56,0,0,1,83,293.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.6932px 262.75px"
    },
    id: "ellc60wovown",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.59,315.49c-1.27.65-4.64-2.24-5.58-2.94a11.85,11.85,0,0,1-3.69-4.69,11.05,11.05,0,0,1-.65-6.67,26.19,26.19,0,0,1,1-3.48c.38-1.13.77-2.25,1.15-3.37a8.71,8.71,0,0,0,.68-3.43c-.18-2.35-2.17-4.09-4-5.6-2-1.67-4.08-3.84-3.92-6.66a9.89,9.89,0,0,1,2.77-5.76c1.44-1.64,3.11-3.07,4.42-4.8a6.91,6.91,0,0,0,1.63-4.31,7.24,7.24,0,0,0-.81-2.78c-.9-1.88-2.13-3.63-2.72-5.63s-.36-4.45,1.25-5.78c1.32-1.09,3.2-1.16,4.9-1a11.07,11.07,0,0,1,4.43,1.81c4.34,2.71,6.62,8.14,11.27,10.29a47.45,47.45,0,0,0,5.67,1.69c1.88.6,3.78,1.67,4.57,3.48,1.56,3.56-1.88,7.69-.84,11.44.91,3.32,4,4.73,5.66,7.76a7,7,0,0,1,.62,4.32,20.6,20.6,0,0,1-2.17,7.14A65.45,65.45,0,0,1,80,303.15S58.79,315.39,58.59,315.49Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "65.0388px 282.055px"
    },
    id: "el4ufzk2me7lx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.89,309.09h0a.57.57,0,0,1-.51-.61c2-22.05-7.15-47-14.36-54.43a.56.56,0,0,1,.8-.78c7.36,7.62,16.73,33,14.67,55.31A.57.57,0,0,1,70.89,309.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "63.8331px 281.109px"
    },
    id: "el4lj5oh2nzaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7,281.9a.51.51,0,0,1-.17,0,74.21,74.21,0,0,0-15.9-3.39.55.55,0,0,1-.5-.61.52.52,0,0,1,.6-.5,75.55,75.55,0,0,1,16.19,3.45.56.56,0,0,1-.22,1.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "60.6995px 279.662px"
    },
    id: "eltleiajkdbae",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7",
    className: "animable",
    style: {
      transformOrigin: "231.044px 60.5026px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-7",
    className: "animable",
    style: {
      transformOrigin: "231.044px 60.5026px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.05,21.42,196.51,63.31a2.48,2.48,0,0,0-1.12,1.94V95.42a2.43,2.43,0,0,0,1.12,1.92l4,2.25a2.51,2.51,0,0,0,2.25,0l72.54-41.89a2.48,2.48,0,0,0,1.12-1.94V25.58a2.44,2.44,0,0,0-1.13-1.92l-4-2.25A2.49,2.49,0,0,0,269.05,21.42Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "235.905px 60.5026px"
    },
    id: "elol6nrsiz3td",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.65,98.93V68.77a2.48,2.48,0,0,1,1.12-1.94l72.54-41.89c.62-.36,1.12-.07,1.12.64V55.75a2.48,2.48,0,0,1-1.12,1.94L202.77,99.58C202.15,99.94,201.65,99.65,201.65,98.93Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "239.04px 62.2599px"
    },
    id: "eliij4hizeym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpmpbgnuqf5p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.77,99.58a2.54,2.54,0,0,1-2.25,0l-4-2.25a2.42,2.42,0,0,1-1.12-1.92V65.25a2.36,2.36,0,0,1,.35-1.14L202,67.67a2.16,2.16,0,0,0-.33,1.1V98.93C201.65,99.59,202.11,100,202.77,99.58Z",
    style: {
      opacity: 0.2,
      transformOrigin: "199.085px 81.9764px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnwpbn0vqqgc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.41,25.38c-.08-.56-.54-.76-1.1-.44L202.77,66.83a2.29,2.29,0,0,0-.79.84l-6.24-3.56a2.2,2.2,0,0,1,.77-.8l72.54-41.89a2.51,2.51,0,0,1,2.25,0l4,2.24A2.44,2.44,0,0,1,276.41,25.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "236.075px 44.4119px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.32,88.77c-.7-.42-6-3.38-6.13-3.48a1,1,0,0,1-.23-1.6l9.53-9.88,6.16,3.51-9.52,9.88A1.06,1.06,0,0,0,192.32,88.77Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "193.654px 81.29px"
    },
    id: "elwe3jiit7jyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2fehmqc5rp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.32,88.77c-.7-.42-6-3.38-6.13-3.48a1,1,0,0,1-.23-1.6l9.53-9.88,6.16,3.51-9.52,9.88A1.06,1.06,0,0,0,192.32,88.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "193.654px 81.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.65,77.32l-9.52,9.88a1,1,0,0,0,.64,1.72l8.88,0Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "196.736px 83.12px"
    },
    id: "elglavzv4yihi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,68.07a.22.22,0,0,1,.28,0,.49.49,0,0,1,.12.36v1.61a1.48,1.48,0,0,1-.11.53l-.22.5-2.15,4.74a2.7,2.7,0,0,1,1.2-.2A1.53,1.53,0,0,1,214,76a2.28,2.28,0,0,1,.59,1,5.61,5.61,0,0,1,.21,1.65,8.46,8.46,0,0,1-.3,2.27,9.21,9.21,0,0,1-.84,2,8.63,8.63,0,0,1-1.27,1.71A6.85,6.85,0,0,1,210.8,86a4.45,4.45,0,0,1-1.79.66,2.05,2.05,0,0,1-1.27-.23,1.83,1.83,0,0,1-.77-.89,3.7,3.7,0,0,1-.31-1.3.89.89,0,0,1,.11-.5.82.82,0,0,1,.28-.34l1.17-.67a.18.18,0,0,1,.24,0,1,1,0,0,1,.2.3,1.23,1.23,0,0,0,.24.38.66.66,0,0,0,.39.2,1.22,1.22,0,0,0,.61,0,4,4,0,0,0,.9-.4,4.2,4.2,0,0,0,1.45-1.39,3.5,3.5,0,0,0,.55-1.9c0-.68-.18-1.06-.55-1.14a2.13,2.13,0,0,0-1.45.39l-1.23.71a.22.22,0,0,1-.28,0,.5.5,0,0,1-.11-.37v-1.6a1.29,1.29,0,0,1,.11-.53,5,5,0,0,1,.21-.5l2.06-4.53-4.06,2.35a.21.21,0,0,1-.28,0,.46.46,0,0,1-.12-.36V72.64a1.15,1.15,0,0,1,.12-.5.7.7,0,0,1,.28-.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "210.729px 77.35px"
    },
    id: "elpay3ix3xc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.65,66.55a1.29,1.29,0,0,1,.11-.5.76.76,0,0,1,.28-.34l5.54-3.2a.21.21,0,0,1,.28,0,.49.49,0,0,1,.12.36V64.5a1.15,1.15,0,0,1-.12.5.7.7,0,0,1-.28.34l-4.14,2.39-.16,3a4.18,4.18,0,0,1,.79-.75,7,7,0,0,1,.64-.41,3.9,3.9,0,0,1,1.53-.55,1.79,1.79,0,0,1,1.22.3,2.42,2.42,0,0,1,.82,1.18,6.34,6.34,0,0,1,.29,2.08,11,11,0,0,1-.3,2.65,9.07,9.07,0,0,1-.83,2.18,7.17,7.17,0,0,1-2.73,2.86,4.42,4.42,0,0,1-1.75.65,1.78,1.78,0,0,1-1.2-.29,2.14,2.14,0,0,1-.73-1,5,5,0,0,1-.27-1.53,1,1,0,0,1,.11-.5.72.72,0,0,1,.29-.34l1.19-.69a.22.22,0,0,1,.27,0,.43.43,0,0,1,.16.3,1.48,1.48,0,0,0,.28.69.78.78,0,0,0,.44.26.93.93,0,0,0,.56-.06,3.71,3.71,0,0,0,.65-.3A3.6,3.6,0,0,0,222.07,76a4.85,4.85,0,0,0,.51-2.23,1.66,1.66,0,0,0-.51-1.4,1.22,1.22,0,0,0-1.36.08,3.25,3.25,0,0,0-.7.51,3,3,0,0,0-.42.48l-.29.41a1.37,1.37,0,0,1-.34.29l-1.36.79a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "220.666px 71.6944px"
    },
    id: "el19d9h7icn9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.52,72.09a.21.21,0,0,1,.28,0,.49.49,0,0,1,.11.36v2.22a1.1,1.1,0,0,1-.11.5.79.79,0,0,1-.28.35l-1.37.79a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V73.72a1.18,1.18,0,0,1,.12-.5.75.75,0,0,1,.28-.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "227.83px 74.1984px"
    },
    id: "elzbe831h3p8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,69.44a.22.22,0,0,1,.28,0,.5.5,0,0,1,.12.37v2.22a1.15,1.15,0,0,1-.12.5.75.75,0,0,1-.28.34l-1.37.79a.21.21,0,0,1-.28,0,.46.46,0,0,1-.12-.36V71.08a1.11,1.11,0,0,1,.12-.5.79.79,0,0,1,.28-.35Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "232.415px 71.5516px"
    },
    id: "elqvsowzsuucn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68,66.8a.21.21,0,0,1,.28,0,.47.47,0,0,1,.12.36V69.4a1.11,1.11,0,0,1-.12.5.79.79,0,0,1-.28.35l-1.37.79a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V68.43a1.18,1.18,0,0,1,.12-.5.75.75,0,0,1,.28-.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "236.995px 68.9184px"
    },
    id: "elrjzebdzbjus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.5,48.7a.21.21,0,0,1,.28,0,.46.46,0,0,1,.12.36v1.61a1.33,1.33,0,0,1-.11.53c-.07.19-.14.35-.21.5l-2.15,4.73a2.68,2.68,0,0,1,1.2-.19,1.5,1.5,0,0,1,.92.41,2.32,2.32,0,0,1,.59,1,5.64,5.64,0,0,1,.2,1.65,8.57,8.57,0,0,1-.3,2.27,8.76,8.76,0,0,1-.84,2,9,9,0,0,1-1.26,1.71,7.48,7.48,0,0,1-1.59,1.25,4.4,4.4,0,0,1-1.79.66,2.09,2.09,0,0,1-1.26-.23,2,2,0,0,1-.78-.89,3.93,3.93,0,0,1-.31-1.3,1,1,0,0,1,.11-.51.8.8,0,0,1,.29-.33l1.16-.67a.2.2,0,0,1,.25,0,1.52,1.52,0,0,1,.2.31.93.93,0,0,0,.23.37.82.82,0,0,0,.39.21,1.34,1.34,0,0,0,.61,0,3.67,3.67,0,0,0,.9-.4,4.05,4.05,0,0,0,1.45-1.4,3.45,3.45,0,0,0,.56-1.89c0-.68-.19-1.06-.56-1.15a2.16,2.16,0,0,0-1.45.4l-1.22.7a.2.2,0,0,1-.28,0,.46.46,0,0,1-.12-.36V58.46a1.57,1.57,0,0,1,.11-.53c.08-.18.15-.35.22-.49l2.06-4.53-4.07,2.35a.22.22,0,0,1-.28,0,.49.49,0,0,1-.12-.36V53.27a1.11,1.11,0,0,1,.12-.5.79.79,0,0,1,.28-.35Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "244.275px 57.9272px"
    },
    id: "eld7ro2j4wxjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39,57.53a9.83,9.83,0,0,1,.31-2.4c.2-.72.42-1.43.68-2.14l2.8-7.69.15-.39a.8.8,0,0,1,.3-.33l1.33-.76a.2.2,0,0,1,.28,0,.46.46,0,0,1,.12.36.92.92,0,0,1,0,.19c0,.06,0,.1-.06.15l-1.82,5.09a3.37,3.37,0,0,1,1.6-.49,1.83,1.83,0,0,1,1.25.41,2.67,2.67,0,0,1,.81,1.28,6.54,6.54,0,0,1,.29,2.07,10,10,0,0,1-.3,2.45,10.73,10.73,0,0,1-.82,2.25A9.25,9.25,0,0,1,256,59.48a6.57,6.57,0,0,1-1.62,1.34,3.46,3.46,0,0,1-1.62.53,1.87,1.87,0,0,1-1.27-.42,2.67,2.67,0,0,1-.82-1.29A6.46,6.46,0,0,1,250.39,57.53Zm6-3.47a2.15,2.15,0,0,0-.52-1.64c-.35-.32-.84-.29-1.48.08a3.62,3.62,0,0,0-1.48,1.63,5.1,5.1,0,0,0-.52,2.24,2.2,2.2,0,0,0,.52,1.66c.35.34.84.32,1.48-.05a3.62,3.62,0,0,0,1.48-1.65A5.26,5.26,0,0,0,256.4,54.06Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "254.409px 52.5574px"
    },
    id: "eltp8x0d1b9nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.22,52.63a.21.21,0,0,1,.28,0,.49.49,0,0,1,.12.36v2.23a1.11,1.11,0,0,1-.12.49.74.74,0,0,1-.28.35l-1.37.79a.22.22,0,0,1-.28,0,.49.49,0,0,1-.12-.36V54.26a1.18,1.18,0,0,1,.12-.5.75.75,0,0,1,.28-.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "261.535px 54.7384px"
    },
    id: "elb3rkarhr95q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.8,50a.21.21,0,0,1,.28,0,.46.46,0,0,1,.12.36v2.22a1.15,1.15,0,0,1-.12.5.7.7,0,0,1-.28.34l-1.37.79a.2.2,0,0,1-.28,0,.46.46,0,0,1-.12-.36V51.62a1.15,1.15,0,0,1,.12-.5.7.7,0,0,1,.28-.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "266.115px 52.1068px"
    },
    id: "elwttfscvbsnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.38,47.34a.21.21,0,0,1,.28,0,.49.49,0,0,1,.12.36v2.22a1.11,1.11,0,0,1-.12.5.79.79,0,0,1-.28.35l-1.37.79a.22.22,0,0,1-.28,0,.54.54,0,0,1-.11-.37V49a1.33,1.33,0,0,1,.11-.5.82.82,0,0,1,.28-.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "270.7px 49.4484px"
    },
    id: "elzi1j8119suc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-7",
    className: "animable",
    style: {
      transformOrigin: "332.058px 264.733px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-7",
    className: "animable",
    style: {
      transformOrigin: "332.058px 264.733px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.38,373.17a1.49,1.49,0,0,0,1.49-1.48v-95.4a1.49,1.49,0,0,0-3,0v95.4A1.48,1.48,0,0,0,331.38,373.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "331.37px 323.98px"
    },
    id: "el713z7h6rn84",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.36,338.45a1.48,1.48,0,0,0,1.38-.94l29.25-74a1.48,1.48,0,0,0-2.76-1.09l-29.25,74a1.48,1.48,0,0,0,.84,1.93A1.44,1.44,0,0,0,272.36,338.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "286.983px 299.968px"
    },
    id: "elc09ps3q5i8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,329.56a1.47,1.47,0,0,0,1.07-.47l54.44-57.6,54.33,57.36a1.48,1.48,0,1,0,2.15-2l-55.41-58.5a1.51,1.51,0,0,0-1.08-.46h0a1.47,1.47,0,0,0-1.07.47L274.8,327.06a1.49,1.49,0,0,0,1.08,2.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "331.404px 298.725px"
    },
    id: "elwhyt9yq0tie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.41,338.45a1.47,1.47,0,0,0,1.37-2l-29.25-74a1.48,1.48,0,0,0-2.76,1.09l29.26,74A1.47,1.47,0,0,0,390.41,338.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "375.773px 299.983px"
    },
    id: "eloqrb9qe08p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.38,327.27l-3.87,10.21a1.09,1.09,0,0,0,0,.26.54.54,0,0,0,0,.18,1.17,1.17,0,0,0,.58.65,2.63,2.63,0,0,0,2.35,0,1,1,0,0,0,.46-.48s0,0,0,0l0-.14,3.59-9.57Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "273.996px 333.059px"
    },
    id: "elrewjw6euijd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.39,327.27l3.87,10.21a1.09,1.09,0,0,1,0,.26.54.54,0,0,1,0,.18,1.21,1.21,0,0,1-.58.65,2.65,2.65,0,0,1-2.36,0,1.07,1.07,0,0,1-.45-.48s0,0,0,0l0-.14-3.58-9.57Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "388.779px 333.059px"
    },
    id: "el3qrnacqwsgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.67,364.3v8.45a.87.87,0,0,0,.5.7,2.71,2.71,0,0,0,2.42,0,.85.85,0,0,0,.5-.7V364.3A3.63,3.63,0,0,0,329.67,364.3Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "331.38px 368.804px"
    },
    id: "el3cvdudof1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,262.47c0-2.66,2.33-5.49,7.25-8.68,9.1-5.9,35.57-20.68,48.3-27.73a.13.13,0,0,1,.11-.11c9.79-5.94,12.77-31.31,19.54-52.81,2.31-7.33,5.14-11.48,8.5-13.43.79-.46,3.73-2.08,4.38-2.47,6.65-4,15.38.8,26.25,6.75,10,5.48,17.84,12.5,19.42,31.12.95,11.34,0,33-2.26,49.42h0c-3.33,27.42-7.42,27.47-13.36,32.06-10.23,7.9-33.25,19-43,22.82-17.6,6.93-32-3.75-42.71-9a249.41,249.41,0,0,1-28.41-16.84c-2.68-1.95-4.07-3.92-4-6C265.06,266.7,265,263.33,265,262.47Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "332.058px 228.724px"
    },
    id: "elkzzsks0u5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellqb95b45xgc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265,262.47c0-2.66,2.33-5.49,7.25-8.68,9.1-5.9,35.57-20.68,48.3-27.73a.13.13,0,0,1,.11-.11c9.79-5.94,12.77-31.31,19.54-52.81,2.31-7.33,5.14-11.48,8.5-13.43.79-.46,3.73-2.08,4.38-2.47,6.65-4,15.38.8,26.25,6.75,10,5.48,17.84,12.5,19.42,31.12.95,11.34,0,33-2.26,49.42h0c-3.33,27.42-7.42,27.47-13.36,32.06-10.23,7.9-33.25,19-43,22.82-17.6,6.93-32-3.75-42.71-9a249.41,249.41,0,0,1-28.41-16.84c-2.68-1.95-4.07-3.92-4-6C265.06,266.7,265,263.33,265,262.47Z",
    style: {
      opacity: 0.3,
      transformOrigin: "332.058px 228.724px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.5,285.25a248.13,248.13,0,0,1-28.41-16.83c-6.1-4.43-5.54-9,3.2-14.63,12.15-7.88,55.29-31.59,55.29-31.59s62.59,36.94,59.9,43.76-35.06,23.54-47.27,28.34C322.61,301.22,308.22,290.55,297.5,285.25Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "326.3px 259.381px"
    },
    id: "ello3j0aw67xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.13,159.49c6.58-3.46,15.15,1.24,25.74,7,6.78,3.72,12.56,8.13,16.08,16.38l4.47-2.59c-3.51-8.21-9.28-12.62-16.05-16.33-10.87-6-19.6-10.73-26.25-6.75C352.54,157.58,350.23,158.87,349.13,159.49Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "372.275px 169.301px"
    },
    id: "elnkppx55761s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eleu3bd3jh23h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.13,159.49c6.58-3.46,15.15,1.24,25.74,7,6.78,3.72,12.56,8.13,16.08,16.38l4.47-2.59c-3.51-8.21-9.28-12.62-16.05-16.33-10.87-6-19.6-10.73-26.25-6.75C352.54,157.58,350.23,158.87,349.13,159.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "372.275px 169.301px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,166.54c-16.27-8.91-27.75-15.24-34.63,6.6-6.77,21.5-9.75,46.87-19.54,52.81,0,0,6.38,2.1,29.15,13.28,9.35,4.59,15.49,9.22,24.25,14.73,12.88,8.1,11.9,14.12,11.9,14.12,6.4-5.3,9.86-51.81,8.29-70.43S384.89,172,374.87,166.54Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "357.683px 213.194px"
    },
    id: "el843hyk7xgro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elan0x3miv2wc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "357.683px 213.194px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.87,166.54c-16.27-8.91-27.75-15.24-34.63,6.6-6.77,21.5-9.75,46.87-19.54,52.81,0,0,6.38,2.1,29.15,13.28,9.35,4.59,15.49,9.22,24.25,14.73,12.88,8.1,11.9,14.12,11.9,14.12,6.4-5.3,9.86-51.81,8.29-70.43S384.89,172,374.87,166.54Z",
    id: "el3va2o6na6dd",
    className: "animable",
    style: {
      transformOrigin: "357.683px 213.194px"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7",
    className: "animable",
    style: {
      transformOrigin: "203.081px 253.842px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-7",
    className: "animable",
    style: {
      transformOrigin: "203.081px 253.842px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boy--inject-7",
    className: "animable",
    style: {
      transformOrigin: "139.301px 221.734px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158,106.53c8.91.42,14.66,2,19.32,7.48s28.12,38.84,28.12,38.84-4.12,11.56-13.14,10.57L174.62,142Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "181.72px 135.005px"
    },
    id: "elnrb06qqj67d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.74,106.34s9.49.15,13.81,3.18S177.62,113.19,184,122s12.1,16.77,12.1,16.77a27.2,27.2,0,0,1-15.41,11.73l-18.76-22.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "177.42px 128.42px"
    },
    id: "el66b2w4mt8da",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-7",
    className: "animable",
    style: {
      transformOrigin: "157.437px 290.207px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "112.95 372.27 127.74 372.27 127.44 349.62 112.95 351.89 112.95 372.27",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "120.345px 360.945px"
    },
    id: "el6xqu76gnchf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163 357.09 177.02 357.57 176.47 333.46 160.97 332.55 163 357.09",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "168.995px 345.06px"
    },
    id: "elxtjzpustv38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.27,396.07c.43.4.3,3.14-.17,3.88s-5.4,3.27-10.64,3.64c-5,.36-9.49-.31-12.43-2.18s-4.36-3.93-4.64-6.78,0-5.61-1.32-7.81c-1.26-2-3.26-4.31-3.69-5.41-.95-2.39,0-5.81,0-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.745px 389.642px"
    },
    id: "el0hmcibhp8y6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.56,371.15a11.15,11.15,0,0,0,.58,3.18,29.23,29.23,0,0,0,3.07,6.28,26.24,26.24,0,0,0,2.09,2.95c1.51,1.8,3.4,3.28,5,5a10.24,10.24,0,0,1,3.09,6.15c.22,3.93-6,5.26-9.33,5.85a24.19,24.19,0,0,1-10.67-.54,9.79,9.79,0,0,1-7.19-7.83c-.18-1.09-.11-2.2-.24-3.3A15.48,15.48,0,0,0,112.9,382a20.19,20.19,0,0,1-2.34-3.74c-1-2.43-.2-5.17.45-7.59.57-2.09,1.21-4.46,1.94-4.26,0,1.08,0,1.19.78,1.93,1,.93,1,2.33,2.06,3.15a15.47,15.47,0,0,1-.73-2.79,1.58,1.58,0,0,1,.23-1.11,2.83,2.83,0,0,1,1.2-.65,24.42,24.42,0,0,1,4.77-1.09,29.09,29.09,0,0,1,6.66,0,2,2,0,0,1,1.17.68,2.34,2.34,0,0,1,.42,1.34C129.58,368.49,129.53,370.11,129.56,371.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "126.742px 383.288px"
    },
    id: "elpuzp3yn54o9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.74,381.43c-1.46-1.09-6.74-1.11-8.54-.92a10.86,10.86,0,0,0-5.09,1.79,1.16,1.16,0,0,1-1.5-.12h0a1.09,1.09,0,0,1,.11-1.67,11.09,11.09,0,0,1,5.73-2.12,29.17,29.17,0,0,1,7.71.44S134.17,380.13,133.74,381.43Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "126.036px 380.413px"
    },
    id: "el1jd09sij3rk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.1,385.46c-1.84-1.09-7.44-.93-9.24-.74a10.2,10.2,0,0,0-5,1.88,1.17,1.17,0,0,1-1.5-.11h0a1.09,1.09,0,0,1,.11-1.67c1.09-.81,5.2-2.11,7.86-2.3,4.41-.31,5.56.59,5.56.59A3.63,3.63,0,0,1,137.1,385.46Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "129.061px 384.638px"
    },
    id: "elv37yvf1n319",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7,374.17a21.33,21.33,0,0,1,7.54.46c.78.44,1.29,1.67.79,2-1-.55-4.75-.77-6.92-.68a15,15,0,0,0-4.77,1.31c-.37.17-.82.41-1.21.62a1,1,0,0,1-1.45-.45h0a1,1,0,0,1,.38-1.26A14,14,0,0,1,122.7,374.17Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "123.91px 376.029px"
    },
    id: "el7vgvq9k0ne4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.54,373.4a4.76,4.76,0,0,1-.2,3.5c-.48,1-5.83,4-13,3.55a30.06,30.06,0,0,1-14.91-5.21c-2.75-1.82-5.61-2.16-9.18-2.37s-8.26-2-9-3.65.12-4.54.12-4.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.366px 372.588px"
    },
    id: "el3oxmwgvji76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.45,350.9l.57-.12a2.35,2.35,0,0,1,.95,0,1.91,1.91,0,0,1,.89.6,18.39,18.39,0,0,1,1.84,2.89c1.51,2.47,4.68,4.51,8.15,6.37,2.35,1.27,4.66,2.25,7.09,3.34s5.77,1.8,7.72,3.11c2.82,1.91,3.19,6.7,0,8.59-2.78,1.63-10.1,3.4-17.77,1.23-4.18-1.19-8.82-5.65-14.31-6.08-3.49-.28-10.09-1.26-12.33-3.91-.83-1.17.27-4.9,1.18-8.11,1-3.51,1.94-9,3.11-8.68a1.58,1.58,0,0,0,.6,1.31,18.07,18.07,0,0,0,1.48,1.13,9.36,9.36,0,0,1,1.93,2.78,2.07,2.07,0,0,0,1,1.07c.59.22,1-.15,1.55-.39a3,3,0,0,1,2.08-.15,13.29,13.29,0,0,0-.37-2.06,1.24,1.24,0,0,1-.05-.66,1,1,0,0,1,.45-.5A11,11,0,0,1,175.45,350.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "181.436px 364.017px"
    },
    id: "el589oekbrm0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.59,358.7A3.24,3.24,0,0,0,182,357c-1.59-.3-4.39.87-6.13,2.31a1.3,1.3,0,0,0,.19,2.15h0a1.28,1.28,0,0,0,1.48-.16A9.93,9.93,0,0,1,184.59,358.7Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "179.988px 359.289px"
    },
    id: "eldnu0efk8d79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51,361.45a3.74,3.74,0,0,0-3-1.57s-4.15.12-6.72,2.51a1.27,1.27,0,0,0,.18,2.08h0a1.24,1.24,0,0,0,1.43-.17A10,10,0,0,1,189.51,361.45Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "184.42px 362.251px"
    },
    id: "el6f73tw7tise",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.94,363.93a4.17,4.17,0,0,0-3.17-1.42,11.2,11.2,0,0,0-6.43,2.54,1.27,1.27,0,0,0,.18,2.08h0A1.23,1.23,0,0,0,187,367,9.54,9.54,0,0,1,194.94,363.93Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "189.91px 364.914px"
    },
    id: "elxr2b1h3j86p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,191.46c-.91,27.52-1,83.81-1,83.81-.29,3.43-.58,9.52-.84,21.85C113,315,113,360.94,113,360.94a26,26,0,0,0,15.56-1.06s10.91-62.06,13.14-79.77c1.95-15.44,5.26-57.41,5.26-57.41l6.75,50.43a173.15,173.15,0,0,0-.46,23.73c.58,8.19,8.91,50.29,8.91,50.29s6.2,2.88,14.73,0c0,0,.12-66.51.27-74,.16-8.57-.78-96.42-.78-96.42Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "145.089px 269.197px"
    },
    id: "elhazwkzqsi4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv0acksg7nw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.2,191.46c-.91,27.52-1,83.81-1,83.81-.29,3.43-.58,9.52-.84,21.85C113,315,113,360.94,113,360.94a26,26,0,0,0,15.56-1.06s10.91-62.06,13.14-79.77c1.95-15.44,5.26-57.41,5.26-57.41l6.75,50.43a173.15,173.15,0,0,0-.46,23.73c.58,8.19,8.91,50.29,8.91,50.29s6.2,2.88,14.73,0c0,0,.12-66.51.27-74,.16-8.57-.78-96.42-.78-96.42Z",
    style: {
      opacity: 0.3,
      transformOrigin: "145.089px 269.197px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elglffn4d9v7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.91,222.7s10-2.81,17.35-9.95c0,0-3.35,6.27-13.31,12.1l2.13,44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "155.585px 240.8px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-7",
    className: "animable",
    style: {
      transformOrigin: "143.946px 121.835px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.64,105.36c-5.58.54-13.38.61-18.92,1.17-3.84,1.58-11.22,8-10.67,12.6,2,17.15,5.63,45.47,5.63,45.47l-1.09,29.57c7.67,7.65,43.89,10.63,62.38-1.62,0,0-.6-53.51-1.87-62.53-2.28-16.22-4.28-22.24-12.65-23.68S139.64,105.36,139.64,105.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "143.495px 153.061px"
    },
    id: "elq8w36qiydw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltg04gknxqo9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 155.53,
    cy: 65.18,
    r: 17.28,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.53px 65.18px",
      transform: "rotate(-68.91deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.55,77.2s2.69,13.19,3.79,15.36a6,6,0,0,0,3.42,2.8l-.11-9.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.155px 86.28px"
    },
    id: "elpe128jkv05f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.23,58.38a6.49,6.49,0,0,0-5.38,1.84c-2.33,2.34-1.11,9.73,1.7,17l5.27.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.721px 68.1001px"
    },
    id: "el54243fd1w33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,77.87c-1.06.63-2.55-1.42-3.84-2.8s-5.54-3.28-7.7,1.18,1.78,10.61,5.12,11.69c5.77,1.86,6.67-1.83,6.67-1.83l.23,21.48h0c7.11,9.27,27.05,8.67,18.83-1l0-6.35s5.23.84,7.78.47c4.26-.62,7-4,8.29-8.54,2.14-7.37,3-13.33,1.34-27.87C167.38,48.34,148.86,48,138.8,54.22S132.4,77.87,132.4,77.87Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "145.117px 82.3364px"
    },
    id: "eledsn9p2xzop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.39,79.65c-.53,0-2.53-3.37-3.83-4.58-1.81-1.67.67-16.69.67-16.69a7.28,7.28,0,0,1,1.33-8.1c2.52-2.73,6-6.06,17.37-4.62,8.08,1,16.85,3.63,24,.2a12.08,12.08,0,0,1-4.32,12.81s-2.59,1.64-9.37,2.4-17.31-.31-18.75-.52c-2-.28-2.39,1.62-3.5,6.8C135,71.91,134.18,79.63,132.39,79.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.131px 62.4813px"
    },
    id: "elim3vgxeg72o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.23,59.55l-6.36-3.49a3.52,3.52,0,0,1,4.85-1.56A3.81,3.81,0,0,1,129.23,59.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.259px 56.8113px"
    },
    id: "elof3q9tsvrln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.75,100.22s-9.47-2-12.77-3.78a11,11,0,0,1-4.55-4.58A15,15,0,0,0,137,97.23c2.4,3.12,14.74,5.52,14.74,5.52Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "143.09px 97.305px"
    },
    id: "elq6zppoyezt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.41,77.22a1.9,1.9,0,1,1-1.88-2A1.94,1.94,0,0,1,153.41,77.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.512px 77.1199px"
    },
    id: "ela730ng6yyqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.26,68.38l-4,2.41a2.45,2.45,0,0,1,.81-3.27A2.27,2.27,0,0,1,152.26,68.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.101px 68.9866px"
    },
    id: "el3yysyr26jj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,72.94l-3.59-3a2.26,2.26,0,0,1,3.25-.36A2.46,2.46,0,0,1,168.59,72.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.05px 70.9954px"
    },
    id: "el7kkxwzuju6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.05,77.22a1.85,1.85,0,0,1-1.83,1.88,1.87,1.87,0,0,1-1.81-1.92,1.82,1.82,0,1,1,3.64,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.23px 77.23px"
    },
    id: "elhl106itpm4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.34 74.76 157.63 86.19 163.8 84.86 158.34 74.76",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "160.715px 80.475px"
    },
    id: "el1s54eu2vaoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.08,91.21a1.82,1.82,0,1,1-1.82-1.82A1.81,1.81,0,0,1,154.08,91.21Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "152.26px 91.21px"
    },
    id: "el3vcsdrmwbf5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,85.19c4.25-4.57,7.19-8,11-11.94,2.19-2.21,3.6-3.81,5.72-6.09,1.46-1.57,2.36-2.93,3.83-3.31a12,12,0,0,0,4.45-2.41,26.78,26.78,0,0,0,2.23-2.29A37.53,37.53,0,0,1,134,52.39c3.24-1.94,6.74-3.3,10-5.12,2-1.09,4.16-3,2.14-5.24a5.45,5.45,0,0,0-2.35-1.42c-5.34-1.74-10.32-.31-15.84.47a41.49,41.49,0,0,0-6.69,1.51A11.63,11.63,0,0,0,118.1,44a15.53,15.53,0,0,0-3.54,4.06C111.74,52,107,55.68,103.13,58.57c-4.47,3.4-8.86,7.05-13.44,10.26A158.1,158.1,0,0,0,76.2,79.23c-3.54,3.1-3.18,5.15-2.82,6.12,2,5.59,4.7,7.81,7.81,11.47,6.48,7.63,34.62,36.38,34.62,36.38l4.37-8.07a20.45,20.45,0,0,0-4.56-25.2C109.73,94.81,103.36,89.26,98.39,85.19Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "110.055px 86.4921px"
    },
    id: "elcfwwe1znr3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,106c-8-6.24-22.14-18.28-22.14-18.28s-.56,14.15-10.79,21.07c0,0,18.71,20,23.62,24.81,4.56-1,8.47-4.68,9.78-11.74C126.68,109.88,124,106,124,106Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "108.207px 110.66px"
    },
    id: "elg97u2ewpi1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,85.19a20.67,20.67,0,0,1-10.22,5.55s4.63,1.38,12.09-4Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "94.215px 88.0443px"
    },
    id: "el6qzhdrcjm0e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lista--inject-7",
    className: "animable",
    style: {
      transformOrigin: "239.585px 303.565px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-7",
    className: "animable",
    style: {
      transformOrigin: "239.585px 303.565px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.27,385.61c-2-1.13-3.7-1.35-5-.63-1.4.81-2.21,2.83-2.21,5.53v19.55c0,5.8-2.05,10.21-5.77,12.45l22.08-12.73v-7.54C227.42,396.09,223.23,388.47,218.27,385.61Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "216.33px 403.537px"
    },
    id: "elhkidl0upfde",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.79,424.3c-1.42-.82-2.68-1-3.55-.5s-1.57,2.06-1.57,4.08v12.83c0,3.49-1.3,6.24-3.57,7.55l15.82-9.12v-1.88C259.92,432.47,256.66,426.53,252.79,424.3Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "252.01px 435.891px"
    },
    id: "elmv3kqiebvsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elteih2js9o1h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.27,385.61c-2-1.13-3.7-1.35-5-.63-1.4.81-2.21,2.83-2.21,5.53v19.55c0,5.8-2.05,10.21-5.77,12.45l22.08-12.73v-7.54C227.42,396.09,223.23,388.47,218.27,385.61Z",
    style: {
      opacity: 0.15,
      transformOrigin: "216.33px 403.537px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnmgewghed1g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.79,424.3c-1.42-.82-2.68-1-3.55-.5s-1.57,2.06-1.57,4.08v12.83c0,3.49-1.3,6.24-3.57,7.55l15.82-9.12v-1.88C259.92,432.47,256.66,426.53,252.79,424.3Z",
    style: {
      opacity: 0.15,
      transformOrigin: "252.01px 435.891px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331,421.4l-13.29,7.67-1.73,1-35.79,20.64v9.38c0,3.18-1.15,5.64-3.25,6.92l52.68-30.38c2.18-1.26,3.38-3.75,3.38-7v-9.38Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "304.97px 443.63px"
    },
    id: "ell1jwwx9dak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.98 420.25 317.18 428.21 315.45 429.21 278.17 450.71 280.17 450.71 315.96 430.07 317.69 429.07 330.98 421.4 332.98 420.25 330.98 420.25",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "305.575px 435.48px"
    },
    id: "elq8jxsdb6dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,190.4V211c0,4.14-2.73,5.92-6.1,4a13.48,13.48,0,0,1-6.09-10.55v-7Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "154.275px 203.086px"
    },
    id: "elshpwi3luyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.46,172.19a2.35,2.35,0,0,0-2.17-.38,3.09,3.09,0,0,0-.92,2.63V211c0,2.72-1,4.9-2.79,6l11-6.33V181.48C170.55,178,168.22,173.78,165.46,172.19Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "165.08px 194.347px"
    },
    id: "eld75y753o1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.37 189.25 160.37 190.4 148.18 197.43 146.18 197.43 160.37 189.25",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "153.275px 193.34px"
    },
    id: "elqnpxhf25p8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.73,419.63V406.8c0-5.52-3.64-12.1-8.13-14.69-2.09-1.21-4-1.34-5.44-.56l-.31.18-18.53,10.69-1.87,1.07-32,18.46c1.43-.71,3.29-.56,5.33.62,4.49,2.59,8.13,9.17,8.13,14.69v12.83c0,5.53,3.64,12.1,8.12,14.7s8.13.49,8.13-4.7v-9.38l37.28-21.5,1.73-1A18.14,18.14,0,0,1,314.73,419.63Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "282.81px 428.482px"
    },
    id: "elzyipgllehpt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.23,400.87V371.78c0-6.91-4.54-15.13-10.15-18.37-2.61-1.5-5-1.66-6.79-.71l-.46.27-35.35,20.38-1.7,1-15.19,8.76c1.79-.89,4.12-.7,6.68.77,5.61,3.24,10.15,11.46,10.15,18.37v29.09c0,5.53,3.64,12.1,8.13,14.69s8.12.22,8.12-5.31V427.88c0-2.93,1-5,2.66-5.86l.13-.07,32-18.46,1.87-1.07A13.56,13.56,0,0,1,282.23,400.87Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "247.46px 399.593px"
    },
    id: "elb989r0197zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.36,358V151c0-4.14-2.73-9.08-6.09-11a4.16,4.16,0,0,0-4.08-.42l-.24.14L162.45,170a4.21,4.21,0,0,1,4,.46c3.36,1.94,6.09,6.88,6.09,11v207c0,11.05,7.76,24.48,17.32,30l1.92,1.11c9.57,5.52,17.32,1.24,17.32-9.55V390.51c0-3.52,1.18-6,3.09-7.19l.39-.22,15.19-8.76,1.7-1A34.33,34.33,0,0,1,225.36,358Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "195.96px 280.606px"
    },
    id: "el2oaahon60bg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.17,450.71v9.38c0,3.18-1.15,5.64-3.25,6.92l-.24.14a6.22,6.22,0,0,1-3,.75,9.37,9.37,0,0,1-4.63-1.38c-5.11-3-9.12-10.17-9.12-16.43V437.26c0-4.79-3.26-10.73-7.13-13-1.42-.82-2.68-1-3.55-.5s-1.57,2.06-1.57,4.08v12.83c0,3.49-1.3,6.24-3.57,7.55s-4.84,1.06-7.55-.51c-5.12-2.95-9.13-10.16-9.13-16.42V402.24c0-6.15-4.19-13.77-9.15-16.63-2-1.13-3.7-1.35-5-.63-1.4.81-2.21,2.83-2.21,5.53v19.55c0,5.8-2.05,10.21-5.77,12.45l-.31.18h0c-3.9,2.17-8.95,1.69-14.22-1.36l-1.92-1.11c-10.1-5.83-18.32-20.07-18.32-31.73v-207c0-3.44-2.33-7.7-5.09-9.29a2.35,2.35,0,0,0-2.17-.38,3.09,3.09,0,0,0-.92,2.63V211c0,2.72-1,4.9-2.79,6l-.3.17a6.08,6.08,0,0,1-6-.47,15.49,15.49,0,0,1-7.09-12.29v-7h2v7A13.48,13.48,0,0,0,154.27,215c3.37,1.94,6.1.16,6.1-4v-36.6c0-2.13.72-3.63,1.88-4.33l.2-.11a4.21,4.21,0,0,1,4,.46c3.36,1.94,6.09,6.88,6.09,11v207c0,11.05,7.76,24.48,17.32,30l1.92,1.11c9.57,5.52,17.32,1.24,17.32-9.55V390.51c0-3.52,1.18-6,3.09-7.19l.39-.22c1.79-.89,4.12-.7,6.68.77,5.61,3.24,10.15,11.46,10.15,18.37v29.09c0,5.53,3.64,12.1,8.13,14.69s8.12.22,8.12-5.31V427.88c0-2.93,1-5,2.66-5.86l.13-.07c1.43-.71,3.29-.56,5.33.62,4.49,2.59,8.13,9.17,8.13,14.69v12.83c0,5.53,3.64,12.1,8.12,14.7s8.13.49,8.13-4.7v-9.38Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "213.17px 318.777px"
    },
    id: "ellbznrcpe68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elalwtevojbfi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.42,409.78v-7.54c0-6.15-4.19-13.77-9.15-16.63-2-1.13-3.7-1.35-5-.63-1.4.81-2.21,2.83-2.21,5.53v1.57c0-5.36,9.28-5.17,9.28,9.8v12Z",
    style: {
      opacity: 0.07,
      transformOrigin: "219.24px 399.222px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3scegbnah5l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.92,439.14v-1.88c0-4.79-3.26-10.73-7.13-13-1.42-.82-2.68-1-3.55-.5s-1.57,2.06-1.57,4.08v6.42c0-6.42,7-2.92,7,1.86v6Z",
    style: {
      opacity: 0.07,
      transformOrigin: "253.795px 432.801px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elh5ypqa2lgnd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.55,210.72V181.48c0-3.44-2.33-7.7-5.09-9.29a2.35,2.35,0,0,0-2.17-.38,3.09,3.09,0,0,0-.92,2.63V181c0-4.45,4.86-2.86,4.86,5.42v26.21Z",
    style: {
      opacity: 0.08,
      transformOrigin: "166.447px 192.162px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-7",
    className: "animable",
    style: {
      transformOrigin: "231.253px 302.612px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.93,407.33a3.12,3.12,0,0,0-1.39,2.41c0,.89.63,1.25,1.39.81a3.1,3.1,0,0,0,1.4-2.41C311.33,407.25,310.7,406.89,309.93,407.33Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "309.935px 408.94px"
    },
    id: "eluiw4tstqjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.93,423.31a3.09,3.09,0,0,0-1.39,2.41c0,.89.63,1.25,1.39.8a3.07,3.07,0,0,0,1.4-2.41C311.33,423.23,310.7,422.87,309.93,423.31Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "309.935px 424.918px"
    },
    id: "elkpsvebfo2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,395.56a3.09,3.09,0,0,0,2.74.48.85.85,0,0,0,.28-1.58,3.09,3.09,0,0,0-2.74-.49A.85.85,0,0,0,301,395.56Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "302.503px 395.006px"
    },
    id: "elzfvdbiijffl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt7olsuj2q1i"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "281.556px 430.007px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.86,420.73a.52.52,0,0,1-.44-.25.52.52,0,0,1,.19-.69l39.19-22.62a.5.5,0,1,1,.5.86l-39.19,22.63A.59.59,0,0,1,257.86,420.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "277.476px 408.902px"
    },
    id: "el7dtqkk73xlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.2,426.28a.5.5,0,0,1-.25-.93l39.2-22.63a.5.5,0,0,1,.68.18.5.5,0,0,1-.18.68l-39.2,22.63A.45.45,0,0,1,263.2,426.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "282.801px 414.467px"
    },
    id: "elh9j109p37u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9,433.93a.5.5,0,0,1-.25-.93l39.2-22.63a.5.5,0,0,1,.5.87l-39.2,22.63A.51.51,0,0,1,265.9,433.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.503px 422.117px"
    },
    id: "el3ky85q7z9dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,441.83a.5.5,0,0,1-.25-.93l39.19-22.63a.5.5,0,1,1,.5.87l-39.19,22.63A.54.54,0,0,1,266,441.83Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.6px 430.016px"
    },
    id: "el2awmodkob5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.07,449.73a.5.5,0,0,1-.25-.93L305,426.17a.5.5,0,1,1,.5.87l-39.19,22.63A.54.54,0,0,1,266.07,449.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.664px 437.916px"
    },
    id: "el6t81htafho9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.17,450.89V452L269,457.32a.47.47,0,0,1-.25.07.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "273.213px 454.14px"
    },
    id: "elos4z6co6nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.17,459.52v.57c0,.2,0,.4,0,.59l-3.8,2.19a.45.45,0,0,1-.25.07.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "275.898px 461.23px"
    },
    id: "el32kk53rzoi4",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,368.35a3.06,3.06,0,0,0-1.39,2.41c0,.88.62,1.24,1.39.8a3.06,3.06,0,0,0,1.39-2.41C278.79,368.26,278.17,367.9,277.4,368.35Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "277.4px 369.952px"
    },
    id: "eli4yv3ajugw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,385.79A3.06,3.06,0,0,0,276,388.2c0,.88.62,1.24,1.39.8a3.06,3.06,0,0,0,1.39-2.41C278.79,385.7,278.17,385.34,277.4,385.79Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "277.39px 387.392px"
    },
    id: "el41seetabfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.79,404a1.74,1.74,0,0,1-.06.45L276.06,406a1.46,1.46,0,0,1-.05-.38,3.06,3.06,0,0,1,1.39-2.41C278.17,402.78,278.79,403.14,278.79,404Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "277.4px 404.514px"
    },
    id: "elhe48705xdmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.62,356.23a3.09,3.09,0,0,0,2.74.49.85.85,0,0,0,.28-1.58,3.09,3.09,0,0,0-2.74-.49A.85.85,0,0,0,266.62,356.23Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "268.13px 355.685px"
    },
    id: "eldwp6p947nfv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloc96zc8qw1h"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "248.315px 401.03px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.33,381.91a.5.5,0,0,1-.25-.93l39.75-22.92a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-39.75,22.92A.54.54,0,0,1,223.33,381.91Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "243.206px 369.95px"
    },
    id: "elb47ghtgtgrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.22,387.63a.5.5,0,0,1-.25-.93l39.75-22.92a.5.5,0,0,1,.5.87l-39.75,22.92A.54.54,0,0,1,229.22,387.63Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "249.098px 375.672px"
    },
    id: "el5m4gszhs9pb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,395.67a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l39.75-22.92a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-39.75,22.92A.57.57,0,0,1,232.88,395.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "252.753px 383.71px"
    },
    id: "el2q5driomi6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,404.1a.5.5,0,0,1-.25-.93L273,380.25a.5.5,0,1,1,.5.86L233.73,404A.45.45,0,0,1,233.48,404.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "253.39px 392.127px"
    },
    id: "eld0r5vfkwrfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,412.65a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L273,388.79a.5.5,0,0,1,.5.87l-39.75,22.92A.55.55,0,0,1,233.48,412.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "253.367px 400.687px"
    },
    id: "elzyqo3ht53i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,421.19a.5.5,0,0,1-.25-.93L273,397.34a.5.5,0,1,1,.5.86l-39.75,22.92A.45.45,0,0,1,233.48,421.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "253.39px 409.218px"
    },
    id: "eloj0jxsy016",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.49,429.72a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68L273,405.87a.51.51,0,0,1,.69.18.5.5,0,0,1-.19.68l-39.74,22.92A.47.47,0,0,1,233.49,429.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "253.368px 417.762px"
    },
    id: "elxbzqlzogsnm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,431.3v1.16l-9.47,5.46a.55.55,0,0,1-.25.07.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "240.561px 434.645px"
    },
    id: "elv81s6et2xgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,440.64v.07a10.1,10.1,0,0,1-.06,1.12L241.86,444a.47.47,0,0,1-.25.07.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "243.393px 442.355px"
    },
    id: "ely4llmpl5dz",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,158.28a3.09,3.09,0,0,0-1.39,2.41c0,.89.62,1.25,1.39.81a3.09,3.09,0,0,0,1.39-2.41C223.17,158.2,222.55,157.84,221.78,158.28Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 159.89px"
    },
    id: "elv983k9pjusa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.73,144a3.05,3.05,0,0,0,2.74.48.85.85,0,0,0,.28-1.58,3.06,3.06,0,0,0-2.74-.48A.85.85,0,0,0,215.73,144Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "217.24px 143.451px"
    },
    id: "el8kwz5y9qb03",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,183.1a3.06,3.06,0,0,0-1.39,2.41c0,.89.62,1.24,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,183,222.55,182.66,221.78,183.1Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 184.704px"
    },
    id: "elpbtjpai3mia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,199.64a3.08,3.08,0,0,0-1.39,2.41c0,.89.62,1.25,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,199.56,222.55,199.2,221.78,199.64Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 201.248px"
    },
    id: "eln1uwv0liif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,216.18a3.09,3.09,0,0,0-1.39,2.41c0,.89.62,1.25,1.39.81a3.09,3.09,0,0,0,1.39-2.41C223.17,216.1,222.55,215.74,221.78,216.18Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 217.79px"
    },
    id: "elrgg9ews9x6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,232.73a3.06,3.06,0,0,0-1.39,2.41c0,.88.62,1.24,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,232.64,222.55,232.28,221.78,232.73Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 234.332px"
    },
    id: "elqibabhsxv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,249.27a3.06,3.06,0,0,0-1.39,2.41c0,.89.62,1.25,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,249.19,222.55,248.83,221.78,249.27Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 250.878px"
    },
    id: "elzv9h6czuu0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,265.81a3.08,3.08,0,0,0-1.39,2.41c0,.89.62,1.25,1.39.8a3.06,3.06,0,0,0,1.39-2.4C223.17,265.73,222.55,265.37,221.78,265.81Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 267.418px"
    },
    id: "eltjxywrwlkri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,282.36a3.06,3.06,0,0,0-1.39,2.4c0,.89.62,1.25,1.39.81a3.08,3.08,0,0,0,1.39-2.41C223.17,282.27,222.55,281.91,221.78,282.36Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 283.962px"
    },
    id: "el7z9bb74p52j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,298.9a3.06,3.06,0,0,0-1.39,2.41c0,.88.62,1.24,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,298.81,222.55,298.45,221.78,298.9Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 300.502px"
    },
    id: "el74p8so1zgy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,315.44a3.06,3.06,0,0,0-1.39,2.41c0,.89.62,1.25,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,315.36,222.55,315,221.78,315.44Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 317.048px"
    },
    id: "elrx60uag8e1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,332a3.09,3.09,0,0,0-1.39,2.41c0,.89.62,1.25,1.39.81a3.09,3.09,0,0,0,1.39-2.41C223.17,331.9,222.55,331.54,221.78,332Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 333.604px"
    },
    id: "el6s26awyec17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,348.53a3.06,3.06,0,0,0-1.39,2.41c0,.88.62,1.24,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,348.44,222.55,348.08,221.78,348.53Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 350.132px"
    },
    id: "elrhogvuv2w8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,365.07a3.06,3.06,0,0,0-1.39,2.41c0,.89.62,1.24,1.39.8a3.06,3.06,0,0,0,1.39-2.41C223.17,365,222.55,364.63,221.78,365.07Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.78px 366.677px"
    },
    id: "el5zf091ed9p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elox3qzpm1q2h"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "196.51px 281.372px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.63,169.74a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,1,1,.5.87l-40.54,23.4A.45.45,0,0,1,172.63,169.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "192.903px 157.537px"
    },
    id: "elbody1rgxsxu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.34,176.88a.5.5,0,0,1-.25-.93l40.54-23.41a.52.52,0,0,1,.69.19.51.51,0,0,1-.19.68l-40.54,23.41A.54.54,0,0,1,176.34,176.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "196.613px 164.679px"
    },
    id: "elct1i9gezm6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,185.07a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,0,1,.5.87L177.59,185A.57.57,0,0,1,177.34,185.07Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 172.867px"
    },
    id: "elvbc4fej2lr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,193.37a.5.5,0,0,1-.25-.93L217.63,169a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-40.54,23.4A.47.47,0,0,1,177.34,193.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 181.155px"
    },
    id: "elqd6coqmk6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,201.67a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,0,1,.5.87l-40.54,23.4A.47.47,0,0,1,177.34,201.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 189.467px"
    },
    id: "elaz0dtyzvby",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,210a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,0,1,.5.87l-40.54,23.4A.47.47,0,0,1,177.34,210Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 197.797px"
    },
    id: "elggrn5z3ai37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,218.27a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l40.54-23.41a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-40.54,23.4A.47.47,0,0,1,177.34,218.27Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.605px 206.065px"
    },
    id: "el2mc2bp35rjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,226.57a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l40.54-23.41a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-40.54,23.4A.47.47,0,0,1,177.34,226.57Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.605px 214.365px"
    },
    id: "elcnvomcz30x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,234.87a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l40.54-23.41a.5.5,0,1,1,.5.86L177.59,234.8A.47.47,0,0,1,177.34,234.87Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.628px 222.652px"
    },
    id: "el2s0iny9dj2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,243.17a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69l40.54-23.4a.5.5,0,0,1,.5.86L177.59,243.1A.47.47,0,0,1,177.34,243.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.586px 230.978px"
    },
    id: "elzse7fcrbio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,251.47a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69l40.54-23.4a.5.5,0,1,1,.5.86L177.59,251.4A.59.59,0,0,1,177.34,251.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.63px 239.252px"
    },
    id: "el0qelkuwdwmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,259.77a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69l40.54-23.4a.5.5,0,1,1,.5.86L177.59,259.7A.59.59,0,0,1,177.34,259.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.63px 247.552px"
    },
    id: "elm7p4tl1a4vb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,268.06a.5.5,0,0,1-.25-.93l40.54-23.4a.5.5,0,1,1,.5.86L177.59,268A.57.57,0,0,1,177.34,268.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.635px 255.847px"
    },
    id: "el575ox640slo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,276.36a.5.5,0,0,1-.25-.93L217.63,252a.5.5,0,1,1,.5.86L177.59,276.3A.57.57,0,0,1,177.34,276.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.635px 264.132px"
    },
    id: "elq54ph7ulzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,284.66a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,0,1,.5.87l-40.54,23.4A.47.47,0,0,1,177.34,284.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 272.457px"
    },
    id: "eltftf834rr8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,293a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,0,1,.5.87l-40.54,23.4A.47.47,0,0,1,177.34,293Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 280.797px"
    },
    id: "elqikzi8se5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,301.26a.5.5,0,0,1-.25-.93l40.54-23.41a.49.49,0,0,1,.68.19.5.5,0,0,1-.18.68l-40.54,23.4A.47.47,0,0,1,177.34,301.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.611px 289.056px"
    },
    id: "el0r86oid8f85r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,309.56a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l40.54-23.41a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-40.54,23.4A.47.47,0,0,1,177.34,309.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.605px 297.355px"
    },
    id: "elz9dv5czc7yd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,317.86a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l40.54-23.41a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-40.54,23.4A.47.47,0,0,1,177.34,317.86Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.605px 305.655px"
    },
    id: "elndhywvu2irh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,326.16a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l40.54-23.41a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-40.54,23.4A.47.47,0,0,1,177.34,326.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.605px 313.955px"
    },
    id: "el38qpi5517df",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,334.46a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69l40.54-23.4a.5.5,0,1,1,.5.86l-40.54,23.41A.47.47,0,0,1,177.34,334.46Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.63px 322.242px"
    },
    id: "el0vn2zsg6hqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,342.76a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69l40.54-23.4a.5.5,0,1,1,.5.86l-40.54,23.41A.59.59,0,0,1,177.34,342.76Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.63px 330.542px"
    },
    id: "elqlgohhxsd3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,351.06a.5.5,0,0,1-.44-.25.51.51,0,0,1,.19-.69l40.54-23.4a.5.5,0,0,1,.5.86L177.59,351A.59.59,0,0,1,177.34,351.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.586px 338.868px"
    },
    id: "el7us49bqk4s2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,359.35a.5.5,0,0,1-.25-.93L217.63,335a.5.5,0,1,1,.5.86l-40.54,23.41A.57.57,0,0,1,177.34,359.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.635px 347.127px"
    },
    id: "el4yi0ngsr3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,367.65a.5.5,0,0,1-.25-.93l40.54-23.4a.5.5,0,1,1,.5.86l-40.54,23.41A.57.57,0,0,1,177.34,367.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.635px 355.437px"
    },
    id: "elww2x7b8kjqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,376a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,0,1,.5.87l-40.54,23.41A.57.57,0,0,1,177.34,376Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 363.797px"
    },
    id: "el131e0v5czquk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,384.25a.5.5,0,0,1-.25-.93l40.54-23.41a.5.5,0,0,1,.5.87l-40.54,23.4A.47.47,0,0,1,177.34,384.25Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.613px 372.047px"
    },
    id: "el0g2uadzdvxk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.61,392.31a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L217.9,368a.5.5,0,0,1,.5.86l-40.54,23.41A.45.45,0,0,1,177.61,392.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.859px 380.135px"
    },
    id: "elwvw0pkddvbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8,400.29a.5.5,0,0,1-.25-.93L220.09,376a.5.5,0,1,1,.5.86l-40.54,23.41A.57.57,0,0,1,179.8,400.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "200.095px 388.1px"
    },
    id: "el21lukl3mv4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.57,407l25.54-14.74v1.15l-25,14.46a.57.57,0,0,1-.25.06.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "196.238px 400.095px"
    },
    id: "elzaiokrju8jh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.19,412.76l18.92-10.88V403l-18.42,10.59a.45.45,0,0,1-.25.07.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "199.528px 407.77px"
    },
    id: "elcg5aejuqs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.34,416.48l10.77-6.16c0,.4,0,.79,0,1.17l-10.23,5.85a.45.45,0,0,1-.25.07.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "203.623px 413.865px"
    },
    id: "el83avbqqdnzl",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elg7dok2eufvw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "155.773px 203.515px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.37,196.47v1.15l-8.45,4.88a.45.45,0,0,1-.25.07.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "155.773px 199.52px"
    },
    id: "eluwmivbqfvz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,205.73v1.15l-6.26,3.61a.45.45,0,0,1-.25.07.5.5,0,0,1-.25-.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "156.868px 208.145px"
    },
    id: "el8fa083gpfu4",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-7",
    className: "animable",
    style: {
      transformOrigin: "220.721px 166.943px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.36,154.66s-.69,6.28-.84,7.77-4.92,5-8.18,6.52-6.82,3.33-4.35,7.84c2.28,4.16,8.1,4.17,10.95,3.54s6.3-4.08,7.07-8.78c1-6-1.16-11.84-.95-15.28S226.73,152.39,225.36,154.66Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "220.721px 166.943px"
    },
    id: "elrdt07gk9lh",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable);
export default __webpack_public_path__ + "static/media/available.49f89e1afdef97ffa957e704014ff63a.svg";
export { ForwardRef as ReactComponent };